import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export interface User {
  id: number;
  email: string;
  name: string;
  profile_type?: string;
}

export interface SessionData {
  user: User | null;
  admin: User | null;
}

export const sessionApi = {
  get: async (): Promise<SessionData> => {
    const { data } = await axios.get("/auth/session.json");
    return data;
  },
};

export const sessionKeys = {
  current: ["session"] as const,
};

export function useSession() {
  return useQuery({
    queryKey: sessionKeys.current,
    queryFn: sessionApi.get,
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
}
